export default __webpack_public_path__ + "static/media/plant.18984249.png";